import { NgModule } from '@angular/core';
import { DomainRoutes } from './domain.routes';
import { PrimecapModule } from './primecap/primecap.module';

@NgModule({
  imports:[
    PrimecapModule,
    DomainRoutes
  ],
  declarations: [
  ]
})
export class DomainModule{}